import axios from "axios";
import config from "../Config.json";

const GetUserList = async (requestType) => {
    const authToken  = localStorage.getItem('token')
    axios.defaults.headers.common['Authorization'] = authToken;  
    try {
        const response = await axios.get(`${config.API_URL}/app/userslist/${requestType}`,)
        return response
    } catch (error) {
        return error
    }
}

export default GetUserList;